import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../../api-config';

const AgentTable = () => {
  const [agents, setAgents] = useState([]);

  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchAgents = async () => {
      try {
        const response = await axios.get(`${API_URL}/trading-api/agent/my_agents`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        setAgents(response.data);
      } catch (error) {
        console.error("There was an error fetching the agents!", error);
      }
    };

    fetchAgents();
  }, [token]);

  return (
    <div className='h-full w-full p-4'>
      <h1 className='text-xl font-bold mb-4 text-white'>Mis Agentes</h1>
      <table className='min-w-full border rounded-lg border-gray-200'>
        <thead className='bg-blue-600'> 
          <tr>
            <th className='py-2 px-4 border-b text-white'>Name</th>
            <th className='py-2 px-4 border-b text-white'>Created By</th>
            <th className='py-2 px-4 border-b text-white'>DB</th>
            <th className='py-2 px-4 border-b text-white'>Type</th>
          </tr>
        </thead>
        <tbody>
          {agents.map((agent) => (
            <tr key={agent.id} className='bg-transparent'>
              <td className='py-2 px-4 border-b text-white'>
                <Link to={`/agentes/detail/${agent.id}`} className='text-white hover:text-gray-300'>
                  {agent.name}
                </Link>
              </td>
              <td className='py-2 px-4 border-b text-white'>{agent.created_by}</td>
              <td className='py-2 px-4 border-b text-white'>{agent.db_name}</td>
              <td className={`py-2 px-4 border-b text-white`}>
                {agent.type}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AgentTable;
